import axios from "axios";
import api from "./api";
import { AddCommentPayload, EditCommentPayload } from "@/types/ProductService.types";
import { showToast } from "@int-traderjoes/ui-components-library";
import  {CategoryManagerListExamples}  from "@/mocks/data/productService/categoryManagerListForPI";
import { getPriorityRoleState } from "@/utils/roleBasedFieldPermissions";

const { productServiceAPI, aggregatedServiceAPI, pimcoreServiceAPI } = api;

const CP_FETCH_PRODUCTS_PATH = "/productInfo/shoppinglist";
const CP_FETCH_VENDOR_ASSESSMENT_PRODUCTS_PATH = "/productInfo/vendorAssessmentList";
const CP_PI_DROP_DOWN_DATA_PATH = "/productInfo/shoplist/onload";
const CP_PI_CATEGORY_DATA_PATH = "/productInfo/categoryData/";
const CP_PI_CATEGORY_MANAGERS_DATA_PATH = "/productInfo/categoryManager/";
const CP_PI_GET_IDEA_PATH = "/productInfo/getIdea/";
const CP_PI_CREATE_OR_UPDATE_IDEA_PATH = "/ProductVendorAggregator/saveIdea";
const CP_PI_IDEA_SHARE_FOR_REVIEW_PATH = "/ProductVendorAggregator/shareForReview/";
// const CP_PI_IDEA_REVIEW_COMPLETE_PATH = "/ProductVendorAggregator/review/complete"; 
const CP_PI_IDEA_PROCCED_TO_VENDOR_PATH = "/ProductVendorAggregator/proceedToVendorAssessment";
const CP_PI_IDEA_REQUEST_FOR_REVISION_PATH = "/ProductVendorAggregator/request/revision/";
const GET_COMMENT_PATH = "/comment";
const ADD_COMMENT_PATH = "/comment";
const EDIT_COMMENT_PATH = "/comment";
const DELETE_COMMENT_PATH = "/comment/";
const CP_PI_DELETE_IDEA_PATH = "/productInfo/delete";
const CP_CREATE_GROUP_PATH = "/productInfo/group";
const CP_UPDATE_GROUP_PATH = "/productInfo/group/";
const CP_DELETE_GROUP_PATH = "/productInfo/group/";
const CP_PI_IDEA_ON_HOLD_PATH = "/ProductVendorAggregator/idea/onhold";
const CP_PI_IDEA_REACTIVATE_FROM_ON_HOLD_PATH = "/productInfo/reactivate/onhold/";
const CP_PI_IDEA_REACTIVATE_FROM_CANCEL_PATH = "/productInfo/reactivate/cancel/";
const CP_PI_IDEA_CANCEL_FROM_ON_HOLD_PATH = "/productInfo/cancel/onhold/";
const CP_PI_IDEA_CANCEL_FROM_IN_PROGRESS_PATH = "/productInfo/inprogress/cancel/";
const FETCH_TASK_PATH = "/task/assigneeUserOrRole";
const FETCH_TASK_GROUP_COUNT_PATH = "/task/groupCount/generic";
const FETCH_TASK_GENERIC_PATH = "/task/generic";
const CP_PI_IDEA_VA_TO_IN_PROGRESS_PATH = "/productInfo/vendorassessment/inprogress/";
const CP_PI_IDEA_VA_TO_CANCEL_PATH = "/productInfo/vendorassessment/cancel/";
const CP_PI_CREATE_IDEA_PATH = "/productInfo/ideas";


const ProductService = {

  fetchProducts: async () => {
    try {
      const resp = await productServiceAPI.get(CP_FETCH_PRODUCTS_PATH);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  fetchVendorAssessmentProducts: async () => {
    try {
      const resp = await productServiceAPI.get(CP_FETCH_VENDOR_ASSESSMENT_PRODUCTS_PATH);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  getDropdownData: async () => {
    try {
      const resp = await productServiceAPI.get(CP_PI_DROP_DOWN_DATA_PATH);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  getAggregatedCategoryData: async (id: number) => {
    try {
      const resp = await productServiceAPI.get( CP_PI_CATEGORY_DATA_PATH + id );
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  getCategoryManagersList: async (id: number) => {
    try {
      const resp = await productServiceAPI.get( CP_PI_CATEGORY_MANAGERS_DATA_PATH + id );
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  getIdea: async (id: number) => {
    try {
      const resp = await productServiceAPI.get( CP_PI_GET_IDEA_PATH + id );
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  createOrUpdateIdea: async (idea: object, vendor: object = []) => {
    try {
      let payload;
      const isVendor = Object.keys(vendor).length > 0;
      const isIdea = Object.keys(idea).length > 0;
     
      payload = {
        ...(isIdea && { idea }),
        ...(isVendor && { vendor }),
      };
      const resp = await aggregatedServiceAPI.post( CP_PI_CREATE_OR_UPDATE_IDEA_PATH, payload );
      return resp.data; 
    } catch (error) {
      throw error;
    }
  },
  shareForReview: async (taskId:number , idea: object, vendor: object = []) => {
    try {
      const payload = { idea, vendor };
      const resp = await aggregatedServiceAPI.post(CP_PI_IDEA_SHARE_FOR_REVIEW_PATH + taskId,
        payload 
      ); 
      return resp.data; 
    } catch (error) {
      throw error;
    }
  },
  proceedToVendor: async (idea: object, vendor: object = [], transitionObject: object) => {
    try {
      const payload = { idea, vendor, transitionObject };  
      const resp = await aggregatedServiceAPI.post( CP_PI_IDEA_PROCCED_TO_VENDOR_PATH,
        payload 
      ); 
      return resp.data;
    } catch (error) {
      throw error; 
    }
  },
  requestForRevision: async (idea: object, vendor: object = [], taskId: number) => {
    try {
      const payload = { idea, vendor };  
      const resp = await aggregatedServiceAPI.post( CP_PI_IDEA_REQUEST_FOR_REVISION_PATH + taskId,
        payload 
      ); 
      return resp; 
    } catch (error) {
      throw error; 
    }
  },
  getComment: async (ideaId: any) => {
    try {
      const resp = await productServiceAPI.get(`${GET_COMMENT_PATH}/${ideaId}`);
      console.log("response", resp);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  addComment: async (payload: AddCommentPayload) => {
    try {
      const resp = await productServiceAPI.post(ADD_COMMENT_PATH, payload);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  editComment: async (payload: EditCommentPayload) => {
    try {
      const resp = await productServiceAPI.put(EDIT_COMMENT_PATH, payload);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  deleteComment: async (id: string) => {
    try {
      const resp = await productServiceAPI.delete( DELETE_COMMENT_PATH + id );
      return resp.status; // Return the response data
    } catch (error) {
      throw error;
    }
  },
  deleteIdea: async (id:{ideaIds: number[]}) => {
    try {
      const resp = await productServiceAPI.post(CP_PI_DELETE_IDEA_PATH, id);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  createGroup: async (groupData : {}) => {
    try {
      const resp = await productServiceAPI.post(CP_CREATE_GROUP_PATH, groupData);
      return resp;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (
          error.response?.status === 409
        ) {
          showToast({
            type: "error",
            message: error.response.data.message,
          });
        }
      } else {
        console.error("Unexpected error:", error);
      }
      throw error; // Re-throw the error to be handled elsewhere
    }
  },
  updateGroup: async (groupData : {}, id: number) => {
    try {
      const resp = await productServiceAPI.put(CP_UPDATE_GROUP_PATH + id, groupData,{withCredentials: true});
      return resp;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // Now `error` is typed as AxiosError
        if (
          error.response?.status === 409
        ) {
          showToast({
            type: "error",
            message: error.response.data.message,
          });
        }
      } else {
        console.error("Unexpected error:", error);
      }
      throw error; // Re-throw the error to be handled elsewhere
    }
  },
  deleteGroup: async (id: number) => {
    try {
      const resp = await productServiceAPI.delete( CP_DELETE_GROUP_PATH + id );
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  onHold: async (idea: object, vendor: object = []) => {
    try {
      let payload;
      const isVendor = Object.keys(vendor).length > 0;
      const isIdea = Object.keys(idea).length > 0;
     
      payload = {
        ...(isIdea && { idea }),
        ...(isVendor && { vendor }),
      };
      const resp = await aggregatedServiceAPI.post( CP_PI_IDEA_ON_HOLD_PATH, payload );
      return resp.data; 
    } catch (error) {
      throw error;
    }
  },
  reactivateFromOnHold: async (ideaId:string) => {
    try {
      const resp = await productServiceAPI.put( CP_PI_IDEA_REACTIVATE_FROM_ON_HOLD_PATH + ideaId ); 
      return resp; 
    } catch (error) {
      throw error; 
    }
  },
  reactivateFromCancel: async (ideaId:string) => {
    try {
      const resp = await productServiceAPI.put( CP_PI_IDEA_REACTIVATE_FROM_CANCEL_PATH + ideaId ); 
      return resp; 
    } catch (error) {
      throw error; 
    }
  },
  cancelFromOnHold: async (ideaId:string) => {
    try {
      const resp = await productServiceAPI.put( CP_PI_IDEA_CANCEL_FROM_ON_HOLD_PATH + ideaId ); 
      return resp; 
    } catch (error) {
      throw error; 
    }
  },
  cancelFromInProgress : async (ideaId:string) => {
    try {
      const resp = await productServiceAPI.put( CP_PI_IDEA_CANCEL_FROM_IN_PROGRESS_PATH + ideaId ); 
      return resp; 
    } catch (error) {
      throw error; 
    }
  },
  /**
   * Fetch task group counts using new generic API
   * Returns grouped task counts by category
   */
  fetchTaskGroupCounts: async () => {
    try {
      const resp = await pimcoreServiceAPI.get(FETCH_TASK_GROUP_COUNT_PATH);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  /**
   * Fetch tasks using new generic API with pagination and group filtering
   * @param options - Pagination and filtering options
   */
  fetchTasksGeneric: async (options: { 
    pageNo?: number; 
    pageSize?: number; 
    groupName?: string;
    assigneeUserId?: string[];
    assigneeRoleId?: string[];
    creationDate?: {
      startDate?: string;
      endDate?: string;
    };
    search?: string;
  } = {}) => {
    try {
      const payload: any = {};
      
      if (options.pageNo !== undefined) {
        payload.pageNo = options.pageNo;
      }
      if (options.pageSize !== undefined) {
        payload.pageSize = options.pageSize;
      }
      if (options.groupName) {
        payload.groupName = options.groupName;
      }
      if (options.assigneeUserId && options.assigneeUserId.length > 0) {
        payload.assigneeUserId = options.assigneeUserId;
      }
      if (options.assigneeRoleId && options.assigneeRoleId.length > 0) {
        payload.assigneeRoleId = options.assigneeRoleId;
      }
      if (options.creationDate) {
        payload.creationDate = options.creationDate;
      }
      if (options.search) {
        payload.search = options.search;
      }
      
      const resp = await pimcoreServiceAPI.post(FETCH_TASK_GENERIC_PATH, payload);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  /**
   * Fetch a single task by ID from pimcore (GET /task/generic/{id}).
   */
  fetchTaskGenericById: async (taskId: string) => {
    const trimmed = String(taskId ?? "").trim();
    if (!trimmed) {
      return null;
    }
    try {
      const path = `${FETCH_TASK_GENERIC_PATH}/${encodeURIComponent(trimmed)}`;
      const resp = await pimcoreServiceAPI.get(path);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  /**
   * Fetch tasks based on user ID, role name, or user roles
   * - If user has Business Admin role (via getPriorityRoleState), uses assigneeRoleId=BA
   * - Otherwise, uses assigneeUserId parameter
   * @deprecated Use fetchTasksGeneric for new implementations
   */
  fetchTasks: async (identifier: { userId?: string; roleName?: string; userRoles?: any[] }) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Check if user has Business Admin role using getPriorityRoleState
      const priorityRole = identifier.userRoles ? getPriorityRoleState(identifier.userRoles) : null;
      const isBusinessAdmin = priorityRole === 'business admin';
      
      if (isBusinessAdmin) {
        queryParams.append("assigneeRoleId", "BA");
      } else if (identifier.userId) {
        queryParams.append("assigneeUserId", identifier.userId);
      }
      
      const resp = await productServiceAPI.get(`${FETCH_TASK_PATH}?${queryParams.toString()}`); 
      return resp.data; 
    } catch (error) {
      throw error; 
    }
  },
  ideaVendorAssessmentToInprogress : async (ideaId:string) => {
    try {
      const resp = await productServiceAPI.put( CP_PI_IDEA_VA_TO_IN_PROGRESS_PATH + ideaId ); 
      return resp; 
    } catch (error) {
      throw error; 
    }
  },
  ideaVendorAssessmentToCancel: async (ideaId: number) => {
    try {
      const resp = await productServiceAPI.put( CP_PI_IDEA_VA_TO_CANCEL_PATH + ideaId );
      return resp.status;
    } catch (error) {
      throw error;
    }
  },
  createIdea: async (idea: object) => {
    try {
      const resp = await productServiceAPI.post(CP_PI_CREATE_IDEA_PATH, idea);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  updateIdea: async (idea: object, ideaId: string) => {
    try {
      const resp = await productServiceAPI.put(CP_PI_CREATE_IDEA_PATH + "/" + ideaId, idea);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ProductService;